module.exports = __webpack_public_path__ + "static/media/copylink-theme.b8b259b6.svg";